import React from "react";

const AlertSuccess = ({ message }) => {
  return (
    <div
      className="mt-4 p-4 mb-4 text-sm text-white bg-green-700 rounded-lg"
      role="alert"
    >
      <span className="font-xs">Success:</span> {message}
    </div>
  );
};

export default AlertSuccess;
